var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddNewWebsite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "97px",
    height: "67px",
    viewBox: "0 0 97 67",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Empty-states",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Migrate-a-website-Copy",
    transform: "translate(-75.000000, -67.000000)",
    stroke: "#6A6666",
    strokeWidth: 2.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(75.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-2",
    fill: "#FFFFFF",
    x: 1.25,
    y: 1.25,
    width: 94.5,
    height: 64.5,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.8278402,10 L18.118659,10 L91.2897718,10 L85.8278402,10 L18.118659,10 L94.0232297,10 L85.8278402,10 Z M13.118659,10 L2,10 L13.118659,10 Z",
    id: "lines",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M48.7705344,26.9 L48.7705344,44.9",
    id: "Line-6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7692308,27.3602348 L48.7692308,45.3602348",
    id: "Line-6",
    strokeLinecap: "round",
    transform: "translate(48.769231, 36.360235) rotate(-90.000000) translate(-48.769231, -36.360235) "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddNewWebsite);
export default __webpack_public_path__ + "static/media/add-new-website.5461b1abe9b9bf08d341a260625708b7.svg";
export { ForwardRef as ReactComponent };